<template>
  <div class="mul-choice mul-choice-new">
    <div class="content-stem">
      <span class="ques-num">{{ currentQuestion.showSerialNum }}</span>
      <span v-html="currentQuestion.content"/>
    </div>
    <div class="content-list">
      <div class="content-option" v-for="(option, index) in currentQuestion.optionList" :key="index">
        <label>
          <input type="checkbox" name="multipleQuestion" :value="option.quesValue" v-model="userAnswer"
                 @change="checkboxFn">
          <i class="ui-icon"></i>
          <strong>{{ option.quesValue }}.&nbsp;</strong>
          <span v-html="option.quesOption"/>
        </label>
      </div>
      <!--普通卷-->
      <div v-if="$route.query.flag === 'ordinary'">
        <div class="is-show-answers"
             @click="toggleAnalyse"
             v-if="isShowAnswer"
             v-text="isAnswerShowNew === true ? '收起答案解析': '查看答案解析'">
        </div>
        <div class="answer-box" v-if="isAnswerShowNew">
          <strong class="answer-right">正确答案：</strong>
          <span v-html="currentQuestion.answer" class="answer-right"></span><br/>
          <template v-if="currentQuestion.analysis!='' &&currentQuestion.analysis!=null ">
            <strong class="answer-ananlysis">答案解析：</strong>
            <span v-html="currentQuestion.analysis"></span><br/>
          </template>
          <!--<span class="answer-assessment" v-if="isShowPointAssessment">【该题针对 <span
            class="answer-assessment-name" v-html="'“'+currentQuestion.pointNames+'”'"></span> 进行考核】</span>-->
          <template v-if="isShowVideoExplain && currentQuestion.vdeioAddr !== null && currentQuestion.vdeioAddr !== ''">
            <strong class="answer-ananlysis">视频解析：</strong>
            <a href="javascript:void(0)"
               class="video-btn"
               @click="videoExplain(currentQuestion.questionID,currentQuestion.pointList)">精讲视频</a>
          </template>


        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import {getCookie} from "@/utils"
import {getPlayAuxiliaryUrl} from '@/api'

export default {
  name: 'ExamMultipleChoice',
  computed: {
    ...mapGetters([
      'currentQuestion',
      'currentQuestionIndex'
    ]),
    userAnswer: {
      get() {
        return this.currentQuestion.userAnswer
      },
      set(value) {
        this.$store.dispatch('setUserAns', value)
      }
    }
  },
  props: {
    isShowProposal: {
      //是否显示建议
      type: Boolean,
      default: false
    },
    isShowAnswerQuestion: {
      //是否显示答疑
      type: Boolean,
      default: false
    },
    isShowAnswer: {
      //是否显示答案项
      type: Boolean,
      default: false
    },
    isAnswerShow: {
      //是否显示答案
      type: Boolean,
      default: false
    },
    isShowQzSeat: {
      //是否显示题目位置
      type: Boolean,
      default: false
    },
    isShowCollect: {
      //是否显示收藏
      type: Boolean,
      default: false
    },
    isShowPointAssessment: {
      //是否显示知识点考核
      type: Boolean,
      default: false
    },
    isShowVideoExplain: {
      //是否显示视频讲解
      type: Boolean,
      default: false
    },
    faqlUrl: {
      //答疑跳转地址
      type: String
    }
  },
  data() {
    return {
      isAnswerShowNew: this.isAnswerShow
    }
  },
  watch: {
    isAnswerShow() {
      this.isAnswerShowNew = false
    }
  },
  mounted() {
    this.isAnswerShowNew = false
  },
  methods: {
    checkboxFn() {
      let value = this.currentQuestion.userAnswer
      let isAnswer = value.length ? 1 : 0
      this.$store.dispatch('setIsAns', isAnswer)
    },
    toggleAnalyse() {
      this.isAnswerShowNew = !this.isAnswerShowNew
    },
    //视频讲解
    videoExplain(questionID, pointList) {
      let pointIDArr = [], pointIDStr = ''
      for (let i in pointList) {
        if (pointList[i] && pointList[i].pointID) {
          pointIDArr.push(pointList[i].pointID)
        }
      }
      pointIDStr = pointIDArr.join(',')
      let params = {
        questionId: String(questionID),
        pointList: pointIDStr
      }
      getPlayAuxiliaryUrl(params).then(res => {
        window.open(res.playUrl, '_blank')
      })
    }
  }
}
</script>
